@if (visible) {
    <div id="welcome-banner" class="pb-4">
        <mat-card class="!bg-success-50 p-4">
            <div class="flex justify-between items-center">
                <h3>Welcome To Cevo®</h3>
                <button type="button" class="cursor-pointer bg-transparent border-0 p-0" aria-label="Hide welcome banner" (click)="hideWelcomeBanner()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <p>
                Cevo is your portal to coordination evolution! With EWA, you can
                secure the spectrum you need, and protect the spectrum you have.
            </p>

            <p>
                Ready to submit your FCC licensing requirements through Cevo?
                Click <b><i>FCC License Application</i></b> at left. Submit as
                little or as much information as you have, and EWA will do the
                rest.
            </p>

            <p>
                If we may be of assistance, please click
                <b><i>Contact Us</i></b> in lower left.
            </p>
        </mat-card>
    </div>
}
